;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "TransactionSuccessful",
  props: {
    success_message: {
      type: String,
      default: "Transaction successful!"
    },
    callback_url: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.back();
    }, 3000);
  },

  methods: {
    back: function back() {
      window.location.href = "/wallet/checkout";
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col gap-5 max-w-lg mx-auto items-center text-center lg:mt-20 mt-10"},[_c('p',{staticClass:"lg:text-[28px] text-2xl leading-normal text-[#4C4F59] font-semibold"},[_vm._v("\n    "+_vm._s(_vm.success_message)+"\n  ")]),_vm._v(" "),_c('button',{staticClass:"px-5 w-[120px] flex-1 btn-primary mt-20",on:{"click":_vm.back}},[_vm._v("\n    Back\n  ")])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5310bb00", __vue__options__)
  } else {
    hotAPI.reload("data-v-5310bb00", __vue__options__)
  }
})()}